var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8107 5.31401V6.75336H4.18937V5.31401C4.18937 4.64583 3.38152 4.3112 2.90902 4.78367L0.21968 7.47301C-0.0732266 7.76592 -0.0732266 8.24076 0.21968 8.53367L2.90902 11.223C3.38149 11.6955 4.18937 11.3609 4.18937 10.6927V9.25336H11.8107V10.6927C11.8107 11.3609 12.6185 11.6955 13.091 11.223L15.7804 8.5337C16.0733 8.24079 16.0733 7.76595 15.7804 7.47304L13.091 4.7837C12.6186 4.3112 11.8107 4.64583 11.8107 5.31401Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162295_2421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 16,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8107 5.31401V6.75336H4.18937V5.31401C4.18937 4.64583 3.38152 4.3112 2.90902 4.78367L0.21968 7.47301C-0.0732266 7.76592 -0.0732266 8.24076 0.21968 8.53367L2.90902 11.223C3.38149 11.6955 4.18937 11.3609 4.18937 10.6927V9.25336H11.8107V10.6927C11.8107 11.3609 12.6185 11.6955 13.091 11.223L15.7804 8.5337C16.0733 8.24079 16.0733 7.76595 15.7804 7.47304L13.091 4.7837C12.6186 4.3112 11.8107 4.64583 11.8107 5.31401Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162295_2421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWidth);
export default __webpack_public_path__ + "static/media/arrow-width.3e489f3a084df0c36d7a4e6544cf0390.svg";
export { ForwardRef as ReactComponent };